import Layout from 'components/layout';
import { SetRoutes } from 'components';
import routes from './routes';
import { useLocation } from 'react-router-dom';

const AnalyticsPage = () => {
  const { pathname } = useLocation();

  const hideLayout = routes.some((i) =>
    i?.hideLayout?.some((i) => pathname.includes(i)),
  );
  return (
    <Layout hideLayout={hideLayout}>
      <SetRoutes routes={routes} />
    </Layout>
  );
};

export default AnalyticsPage;
